'use client'
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import Title from "@/components/Title";
import parser from "html-react-parser";

const MyComponent = ({data}) => {


    return (
        <StyledComponent className={'pt-120 pb-120'}>
            <Container>
                <Row>
                    <Col sm={10}>
                        <Title text={data?.title}/>
                        {
                            data?.desc
                            && parser(data?.desc)
                        }
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    background: #F9F9F9;
`
export default MyComponent;